var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"className":"background-circle","cx":"16","cy":"16","r":"16","fill":"#1565D8","key":0}),React.createElement("path",{"d":"M18.1 12.6a3.887 3.887 0 0 0-3.9 3.88v3.92a.6.6 0 0 0 .6.6h1.4a.6.6 0 0 0 .6-.6v-3.92a1.293 1.293 0 0 1 1.433-1.287c.67.085 1.172.658 1.167 1.334V20.4a.6.6 0 0 0 .6.6h1.4a.6.6 0 0 0 .6-.6v-3.92a3.887 3.887 0 0 0-3.9-3.88z","fill":"#1565D8","key":1}),React.createElement("rect",{"x":"10","y":"13.2","width":"3","height":"7.8","rx":".9","fill":"#1565D8","key":2}),React.createElement("circle",{"cx":"11.5","cy":"10.5","r":"1.5","fill":"#1565D8","key":3})]);
}

LinkedinInline.defaultProps = {"viewBox":"0 0 32 32","width":"32","height":"32","fill":"none"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
